import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase/app";
import _ from "lodash"
import "firebase/auth";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    artikels: [],
    basket: undefined,
    userInfo: {},
    currentUser: undefined,
    homeCarousel: [],
    counter: 0
  },
  mutations: {
    addArtikels: (state, array) => (state.artikels = array),
    makeReservation: (state, { artikel, id, value, doc, confirmed }) => {
      if (id)
        (artikel.id = id),
          (state.basket = {
            artikel,
            value,
            doc,
            confirmed: confirmed ? confirmed : false
          });
    },
    setUserinfo: (state, val) => (state.userInfo = val),
    setCurrentUser: (state, val) => {
      state.currentUser = val;
    },
    setHomeCarousel: (state, val) => {
      state.homeCarousel = val;
      
    },
    increase: state => (state.counter += 1)
  },
  actions: {
    makeReservation: ({ commit }, data) => {
      commit("makeReservation", data);
    },
    clearBasket: ({ state }) => {
      state.basket = undefined;
    },
    logout: ({ commit, state }) => {
      firebase
        .auth()
        .signOut()
        .then(() => {
          state.currentUser = {};
          router.push("/login");
          commit("setCurrentUser", undefined);
        });
    }
  }
});
